<div *ngIf="!currentComponent?.file"
     class="flex flex-column align-items-center justify-content-center no-file-container">
  <div class="no-file-area flex flex-column">
    <label>{{'misc.selectFileConfigSynoptic' | transloco}}</label>
    <div class="flex justify-content-center">
      <button
        [label]="'select.file' | transloco"
        (click)="componentBeingModified = configuration; filesOverlay.toggle($event)"
        pButton
        icon="pi pi-file"
        class="mt-3"
      ></button>
    </div>
  </div>
</div>

<ng-container *ngIf="currentComponent?.file">
  <div class="flex flex-column mb-3 fadein">

    <app-synoptics-form-visualization
      #visualizationComponent
      [currentComponent]="currentComponent"
      [synopticFiles]="synopticFiles">
    </app-synoptics-form-visualization>

    <div class="flex justify-content-between gap-3 align-items-end mb-2 mt-2 flex-wrap">
      <div class="flex flex-column sm:flex-row gap-3 w-full flex-wrap">
        <div class="flex flex-row sm:flex-column w-full sm:w-3 ">
          <label class="mb-2 sm:mr-0 mr-2 no-break-text">{{ 'misc.highlightColor' | transloco }}:</label>
          <app-color-picker
            (colorChange)="visualizationComponent.onHighlightColorChange($event)"
            [changeDelay]="100"
            [color]="visualizationComponent.highlightColor"
            [disabled]="!visualizationComponent.svgLoaded"
            class="w-full"
          ></app-color-picker>
        </div>
        <div class="flex flex-row sm:flex-column w-full flex-grow-1 sm:w-4">
          <label class="mb-2 sm:mr-0 mr-2">{{ 'common.selection' | transloco }}:</label>
          <p-dropdown
            (ngModelChange)="visualizationComponent.selectElementById($event)"
            [filter]="true"
            [ngModel]="visualizationComponent.lastSelectedElementId"
            [options]="visualizationComponent.elementsWithId"
            [disabled]="!visualizationComponent.svgLoaded"
            [placeholder]="'empty.selectedElement' | transloco"
            [virtualScroll]="true"
            class="w-full sm:w-auto"
            filterBy="id"
            itemSize="30"
            optionLabel="id"
            optionValue="id"
            styleClass="w-full"
          ></p-dropdown>
        </div>
        <div class="flex flex-row sm:flex-column w-full flex-grow-1 sm:w-3">
          <label class="mb-2 sm:mr-0 mr-2">{{ 'attribute.component' | transloco }}:</label>
          <div (click)="componentsOverlay.toggle($event)"
               [class]="'custom-input-outline ' + (!visualizationComponent.svgLoaded ? 'p-disabled' : '')  +' justify-content-between w-full'">
            <p class="mb-0 pr-3 pl-1">{{ 'attribute.component' | transloco }} {{ currentComponent.name }}</p>
            <i class="pi pi-arrow-right-arrow-left"></i>
          </div>
        </div>
        <div class="flex flex-row sm:flex-column flex-grow-1 justify-content-end align-items-end">
          <button
            (click)="showPreview = true"
            [label]="'common.preview' | transloco"
            [disabled]="!visualizationComponent.svgLoaded"
            [loading]="!visualizationComponent.svgLoaded"
            class="w-full sm:w-auto"
            icon="pi pi-eye"
            pButton
          ></button>
        </div>
      </div>
    </div>

    <div class="flex flex-column mt-3">
      <p-tabMenu
        #configurationTabMenu
        [activeItem]="configurationTabsActive"
        [model]="configurationTabs"
        styleClass="flex justify-content-center"
      >
        <ng-template let-i="index" let-item pTemplate="item">
          <div>{{ item.label | transloco }}</div>
        </ng-template>
      </p-tabMenu>

      <app-synoptics-form-states
        (changeSelectionById)="visualizationComponent.selectElementById($event)"
        (statesChange)="currentComponent.states = $event; onConfigChange()"
        *ngIf="configurationTabMenu.activeItem.id === 'states'"
        [states]="currentComponent.states"
        [assetMeasurements]="assetMeasurements"
        [deviceMeasurements]="deviceMeasurements"
        [kpis]="kpis"
        [selection]="visualizationComponent.lastSelectedElement"
        [uuidSensorMap]="uuidSensorMap"
        class="mt-3"
      ></app-synoptics-form-states>

      <app-synoptics-form-events
        (changeSelectionById)="visualizationComponent.selectElementById($event)"
        (eventsChange)="currentComponent.events = $event; onConfigChange()"
        *ngIf="configurationTabMenu.activeItem.id === 'events'"
        [events]="currentComponent.events"
        [assetMeasurements]="assetMeasurements"
        [components]="configuration.children"
        [currentComponent]="currentComponent"
        [deviceMeasurements]="deviceMeasurements"
        [devices]="devices"
        [kpis]="kpis"
        [selection]="visualizationComponent.lastSelectedElement"
        [synopticFiles]="synopticFiles ?? []"
        [synopticInfoForm]="synopticInfoForm"
        [synopticUuid]="synopticUuid"
        [uuidDeviceMap]="uuidDeviceMap"
        [uuidSensorMap]="uuidSensorMap"
        class="mt-3"
      ></app-synoptics-form-events>

      <app-synoptics-form-static
        (changeSelectionById)="visualizationComponent.selectElementById($event)"
        (staticsChange)="currentComponent.statics = $event; onConfigChange()"
        *ngIf="configurationTabMenu.activeItem.id === 'static'"
        [statics]="currentComponent.statics"
        [selection]="visualizationComponent.lastSelectedElement"
        class="mt-3"
      ></app-synoptics-form-static>

    </div>

  </div>

  <p-overlayPanel #componentsOverlay [showCloseIcon]="true" [style]="{width: 'min(750px, 100vw)'}" appendTo="body">
    <ng-template pTemplate>
      <div class="flex flex-column">
        <div class="mb-2">
          <button
            (click)="startCreatingComponent(); componentsOverlay.hide();"
            [label]="'misc.createComponent' | transloco"
            icon="pi pi-plus"
            pButton
          ></button>
        </div>
        <p-table
          (selectionChange)="changeComponent($event); componentsOverlay.hide();"
          [paginator]="true"
          [rows]="5"
          [selection]="currentComponent"
          [value]="configuration.children.concat([configuration])"
          responsiveLayout="scroll"
          selectionMode="single"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name" scope="col">{{ 'attribute.component' | transloco }}
                <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th scope="col">{{ 'common.file' | transloco }}</th>
              <th class="text-right" scope="col">{{ 'common.actions' | transloco }}</th>
            </tr>
          </ng-template>
          <ng-template let-component let-rowData pTemplate="body">
            <tr [pSelectableRow]="rowData">
              <td>{{ component.name }}</td>
              <td>
                <app-synoptic-thumbnail
                  [file]="(synopticFiles | find: { name: component.file })"></app-synoptic-thumbnail>
              </td>
              <td>
                <div class="flex justify-content-end">
                  <button
                    (click)="startEditingComponent(component); componentsOverlay.hide();"
                    class="p-button-text p-button-icon-only"
                    icon="pi pi-pencil"
                    pButton
                  ></button>
                  <button
                    (click)="startDuplicatingComponent(component); componentsOverlay.hide();"
                    *ngIf="!component.children"
                    class="p-button-text p-button-icon-only"
                    icon="pi pi-copy"
                    pButton
                  ></button>
                  <button
                    (click)="removeComponent(component.name); componentsOverlay.hide();"
                    *ngIf="!component.children"
                    class="p-button-text p-button-icon-only"
                    icon="pi pi-trash"
                    pButton
                  ></button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-template>
  </p-overlayPanel>

  <p-dialog
    [(visible)]="displayComponentDialog"
    [header]="'misc.' + componentDialogMode + 'Component' | transloco"
    [modal]="true"
    [style]="{width: 'min(550px, 100vw)'}"
  >
    <div *ngIf="componentBeingModified && displayComponentDialog" class="flex flex-column">
      <div class="mb-3 flex flex-column">
        <label class="mb-2">{{ 'attribute.name' | transloco }}</label>
        <input #name [formControl]="componentBeingModifiedNameForm" class="w-full" pInputText>
        <app-validation-errors [control]="componentBeingModifiedNameForm"></app-validation-errors>
      </div>
      <div class="flex flex-column mt-2">
        <label class="mb-2">{{ 'common.file' | transloco }}</label>
        <div
          (click)="filesOverlay.toggle($event);"
          *ngIf="componentDialogMode === 'create'"
          [style.height]="componentBeingModified.file ? '125px' : '33px'"
          class="custom-input-outline mb-3 px-2"
        >
          <div *ngIf="componentBeingModified.file" class="flex flex-column px-2">
            <app-synoptic-thumbnail
              [file]="(synopticFiles | find: { name: componentBeingModified.file })"></app-synoptic-thumbnail>
          </div>
          <p *ngIf="!componentBeingModified.file" class="mb-0 text-gray-600">{{ 'select.file' | transloco }}</p>
          <i class="pi pi-arrow-right-arrow-left"></i>
        </div>
        <div *ngIf="componentDialogMode === 'edit'">
          <app-synoptic-thumbnail
            [file]="(synopticFiles | find: { name: componentBeingModified.file })"></app-synoptic-thumbnail>
        </div>
      </div>
    </div>
    <div class="mt-4 flex justify-content-between">
      <button
        (click)="displayComponentDialog = false"
        [label]="'common.cancel' | transloco"
        class="p-button-danger"
        pButton
      ></button>
      <button
        (click)="applyComponentChanges(); displayComponentDialog = false;"
        [disabled]="!componentBeingModifiedNameForm?.valid"
        [label]="'common.save' | transloco"
        pButton
      ></button>
    </div>
  </p-dialog>

  <p-dialog
    [(visible)]="showPreview"
    [draggable]="false"
    [header]="'common.preview' | transloco"
    [modal]="true"
    [style]="{ width: '90vw', height: '90vh' }"
    contentStyleClass="p-3"
  >
    <app-synoptic-visualization
      *ngIf="showPreview"
      [offsetX]="(screenWidth - screenWidth * 0.9) / 2"
      [offsetY]="(screenHeight - screenHeight * 0.9) / 2"
      [synopticConfiguration]="synopticConfiguration"
      [synopticFiles]="synopticFiles"
    ></app-synoptic-visualization>
  </p-dialog>
</ng-container>

<p-overlayPanel #filesOverlay [showCloseIcon]="true" [style]="{width: 'min(450px, 100vw)'}" appendTo="body">
  <ng-template pTemplate>
    <p-table
      [selection]="componentBeingModified.file"
      [value]="synopticFiles"
      [paginator]="true"
      [rows]="5"
      (selectionChange)="!$event || (componentBeingModified.file = $event.name); onConfigChange(); filesOverlay.hide();"
      selectionMode="single"
      responsiveLayout="scroll"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" pSortableColumn="name">{{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
          <th scope="col">{{'common.image' | transloco}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-file>
        <tr [pSelectableRow]="rowData">
          <td>{{file.name}}</td>
          <td>
            <app-synoptic-thumbnail [file]="file"></app-synoptic-thumbnail>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-overlayPanel>
